import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { ArrowLink } from 'components/arrow-link';
import { CustomEventNames, useMParticleContext } from 'state/mParticle';
import { routes } from 'utils/routing';

const Account = () => {
  const mParticle = useMParticleContext();
  const { formatMessage } = useIntl();
  const onTimsRewardsClick = useCallback(() => {
    mParticle.logNavigationClick(CustomEventNames.BUTTON_CLICK_TIMS_REWARDS);
  }, [mParticle]);

  return (
    <ArrowLink data-testid="tims-rewards" to={routes.timsRewards} onClick={onTimsRewardsClick}>
      {formatMessage({ id: 'thTimsRewards' })}
    </ArrowLink>
  );
};

export default Account;
